export default function SuperadminIndicator({className = ''}) {
    return <span
        className={`inline-flex h-7 w-7 items-center justify-center rounded-md bg-violet-100 text-violet-600 ring-1 ring-inset ring-violet-200 dark:bg-violet-500/20 dark:text-violet-300 dark:ring-violet-500/30 ${className}`}
        title={'Pouze pro superadminy'}
        aria-label={'Pouze pro superadminy'}
    >
        <svg aria-hidden={'true'} className={'h-4 w-4'} viewBox={'0 0 24 24'} fill={'currentColor'}>
            <path d={'M3.783 2.826 12 1l8.217 1.826A1 1 0 0 1 21 3.802v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.789V3.802a1 1 0 0 1 .783-.976ZM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.596l5.219-3.479A4 4 0 0 0 19 13.789V4.604l-7-1.555-7 1.555ZM12 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm-4.473 5A4.5 4.5 0 0 1 12 12a4.5 4.5 0 0 1 4.473 4H7.527Z'}/>
        </svg>
    </span>;
}
